export default "__VITE_ASSET__DKtP2xHI__"